import React, { useEffect, useState } from 'react'
import LikeIcon from '../../../../static/svg/like-icon.svg'
import CommentIcon from '../../../../static/svg/comment-box.svg'
import SaveIcon from '../../../../static/svg/save-icon.svg'
import ShareIcon from '../../../../static/svg/share-icon.svg'

const ArticleActions = (props) => {
  const { slug, comment, share, save } = props
  const [count, setCount] = useState(0)
  const [overLike, setOverLike] = useState(false)
  const [splash, setSplash] = useState(0)

  const handleLikeArticle = () => {
    const data = { slug }
    fetch(`/api/article-likes`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    })
  }

  const getCurrentCount = () => {
    fetch(`/api/article-likes?slug=${slug}`)
      .then((res) => res.json())
      .then((data) => {
        if (data.likes) {
          setCount(data.likes)
        }
      })
  }

  useEffect(() => {
    getCurrentCount()
  }, [])

  const likeCount = (event) => {
    const storedArticleLike = localStorage.getItem(`${slug}_like`)
    if (storedArticleLike) {
      setOverLike(true)
    } else {
      setCount(count + 1)
      localStorage.setItem(`${slug}_like`, true)
      handleLikeArticle()
    }
  }
  return (
    <>
      <div className="article-actions">
        <div className="button-group">
          <div className="like-button-container">
            <button
              onClick={() => {
                likeCount()
                setSplash(1)
              }}
              className="icon-container like-button"
              data-splash={splash}
              onAnimationEnd={() => setSplash(0)}
            >
              <div className="like-button-icon">
                {' '}
                <LikeIcon />
              </div>{' '}
              <span className="icon-span">{count}</span>
            </button>
            {overLike && (
              <p className="warning-message">
                Sry, You can only like once!{' '}
                <span role="img" aria-label="Heart Emoji">
                  ❤️
                </span>
              </p>
            )}
          </div>
          {comment && (
            <div className="icon-container">
              <CommentIcon />
            </div>
          )}
        </div>
        <div className="button-group">
          {share && (
            <div className="icon-container">
              <ShareIcon />
            </div>
          )}
          {save && (
            <div className="icon-container save-icon">
              <SaveIcon />
            </div>
          )}
        </div>
      </div>
      <hr className="article-break" />
    </>
  )
}

export { ArticleActions }
